import Clarity from '@microsoft/clarity';
import { env } from '../config/env';

let initialized = false;
let consentGranted = false;

export function initClarity(): void {
  if (env.VITE_CLARITY_ENABLED !== 'true' || !env.VITE_CLARITY_PROJECT_ID) {
    return;
  }

  if (initialized) return;

  Clarity.init(env.VITE_CLARITY_PROJECT_ID);
  initialized = true;

  // Check if consent was already given
  try {
    const consent = localStorage.getItem('cookie-consent');
    if (consent) {
      const parsed = JSON.parse(consent) as {
        state?: { granted?: string[] };
      };
      if (parsed?.state?.granted?.includes('analytics')) {
        Clarity.consent();
        consentGranted = true;
      }
    }
  } catch {
    // Ignore parse errors
  }
}

export function activateAfterConsent(): void {
  if (!initialized || consentGranted) return;
  Clarity.consent();
  consentGranted = true;
}

export function identifyUser(
  userId: string,
  sessionId?: string,
  pageId?: string,
  friendlyName?: string
): void {
  if (!initialized) return;
  Clarity.identify(userId, sessionId, pageId, friendlyName);
}

export function setTag(key: string, value: string): void {
  if (!initialized) return;
  Clarity.setTag(key, value);
}

export function grantConsent(): void {
  if (!initialized) return;
  Clarity.consent();
  consentGranted = true;
}
